import 'slick-carousel';
import $ from "jquery";

function slider() {

  let next = $('.right_arrow');


    $('.slider_two').slick({
      arrows: true,
      nextArrow: next,
      dots: true,
      customPaging: function(slick, index) {
          var image = $(slick.$slides[index]).find('.slider__img').attr('src');
           return '<img class="slider__dots_img" src="' + image + '" alt="" /> '
      },
      speed: 500,
      initialSlide: 0,
      variableWidth: false,
      fade: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      appendDots: $('.dots_two_container'),
      infinite: true,
    });
}

export default slider;